import { Capacitor } from '@capacitor/core'

/** The native shell (M19b, ADR-111): the SAME web app, bundled by Capacitor into an iOS or Android app. It is installed by definition (its storage is
 *  the app's own, not a browser tab's), its page origin is the shell's (`capacitor://localhost`, `https://localhost`), and it may share a position
 *  with the screen off. Everything that differs from the browser asks these two functions; nothing else reads `Capacitor` directly. */
export type NativePlatform = 'ios' | 'android'

export const isNative = (): boolean => Capacitor.isNativePlatform()

/** 'ios' or 'android' in the native shell, null in a browser. */
export function nativePlatform(): NativePlatform | null {
  if (!isNative()) return null
  const p = Capacitor.getPlatform()
  return p === 'ios' || p === 'android' ? p : null
}

/** The background-geolocation plugin's name (data/livePosition.ts, platform/nativePosition.ts). */
export const BACKGROUND_GEOLOCATION = 'BackgroundGeolocation'

/** Does this shell carry the native plugin? (An older build of the app may not.) */
export const hasNativePlugin = (name: string): boolean => isNative() && Capacitor.isPluginAvailable(name)
